import React, { memo } from 'react'

const FeaturedIcon: React.FC = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="currentColor"
  >
    <path
      d="M9 14.8066L4.63747 17.4347C4.44474 17.5573 4.24326 17.6099 4.03302 17.5924C3.82278 17.5748 3.63881 17.5048 3.48113 17.3821C3.32345 17.2595 3.20081 17.1062 3.11321 16.9222C3.02561 16.7382 3.00809 16.5324 3.06065 16.3046L4.21698 11.3376L0.353774 8.00004C0.178571 7.84236 0.0690701 7.66278 0.0252695 7.4613C-0.018531 7.25981 -0.00539083 7.06271 0.06469 6.86999C0.134771 6.67727 0.239892 6.51958 0.380054 6.39694C0.520216 6.2743 0.712938 6.19546 0.958221 6.16042L6.0566 5.71365L8.02763 1.03576C8.11523 0.825514 8.25101 0.667832 8.43497 0.562711C8.61894 0.45759 8.80728 0.405029 9 0.405029C9.19272 0.405029 9.38107 0.45759 9.56503 0.562711C9.74899 0.667832 9.88477 0.825514 9.97237 1.03576L11.9434 5.71365L17.0418 6.16042C17.2871 6.19546 17.4798 6.2743 17.6199 6.39694C17.7601 6.51958 17.8652 6.67727 17.9353 6.86999C18.0054 7.06271 18.0185 7.25981 17.9747 7.4613C17.9309 7.66278 17.8214 7.84236 17.6462 8.00004L13.783 11.3376L14.9394 16.3046C14.9919 16.5324 14.9744 16.7382 14.8868 16.9222C14.7992 17.1062 14.6765 17.2595 14.5189 17.3821C14.3612 17.5048 14.1772 17.5748 13.967 17.5924C13.7567 17.6099 13.5553 17.5573 13.3625 17.4347L9 14.8066Z"
      fill="currentColor"
    />
  </svg>
))

export { FeaturedIcon }
